import RequestService from "../../services/RequestService";
import FormBase from "../FormBase";
import FormFieldBase from "../../forms/FormFieldBase";
import ValidationBase, { ValidationType } from "../../forms/ValidationBase";
import Professional from '../../models/Professional'
import { RegiaoOptions } from "../../data/Regiao";

export default class PersonalAddressDataForm implements FormBase {

    Region: FormFieldBase;

    constructor(region: string) {
        this.Region = new FormFieldBase(region, [new ValidationBase("", ValidationType.OBRIGATORIO)]);
    }

    static NewInstance(): PersonalAddressDataForm {
        return new PersonalAddressDataForm("");
    }

    async CallInsertOrUpdateApi(Professional: Professional): Promise<any> {
        const dataJson = this.getJsonObjet();
        return RequestService.postCreateOrUpdateRequest(dataJson, Professional.Id);
    }

    ValidateToGoNextStep(): string {
        let propNames = Object.getOwnPropertyNames(this);

        let formIsValid = true;

        for (let index = 0; index < propNames.length; index++) {
            const element = propNames[index];
            const error = this.GetFieldByName(element).ValidateField();

            if (error !== null && error !== "") {
                formIsValid = false;
            }
        }

        if (!formIsValid) {
            return "Por favor, preencha os dados obrigatórios."
        } else {
            return "";
        }
    }

    GetFieldByName(name: string): FormFieldBase {

        switch (name) {

            case "Region":
                return this.Region

            default:
                return new FormFieldBase("", []);
        }
    }

    getJsonObjet() {

        return {
            "ProfessionalId": 0,
            "RequestType": {
                "Id": 5,
                "Name": 'Médico Parceiro'
            },
            "RequestRegion": RegiaoOptions.find(r => r.value === this.Region.Value)?.id,
        }
    }

}